// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  font-size: '11px';
}

.custom-table th,
.custom-table td {
  border: 0.5px solid #f0f4ff;
  padding: 8px;
  text-align: left;

  z-index: 1;
  top: 0;
}

.custom-table th {
  background-color: #fff;
  border-width: 0.1px;
  border-color: aliceblue;
}
.custom-table thead {
  position: sticky;
  z-index: 40;
  top: 0px;
}
.table-container {
  width: 100%;
  height: 400px;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/modules/JobRoles/NewJobRole/RolesForm/Partials/EligibiltyCriteria/Styles.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;;EAEhB,UAAU;EACV,MAAM;AACR;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,QAAQ;AACV;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".custom-table {\n  border-collapse: separate;\n  border-spacing: 0;\n  width: 100%;\n  font-size: '11px';\n}\n\n.custom-table th,\n.custom-table td {\n  border: 0.5px solid #f0f4ff;\n  padding: 8px;\n  text-align: left;\n\n  z-index: 1;\n  top: 0;\n}\n\n.custom-table th {\n  background-color: #fff;\n  border-width: 0.1px;\n  border-color: aliceblue;\n}\n.custom-table thead {\n  position: sticky;\n  z-index: 40;\n  top: 0px;\n}\n.table-container {\n  width: 100%;\n  height: 400px;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
